/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_No_QueryInputs */

const en_ledger_error_no_query = /** @type {(inputs: Ledger_Error_No_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The template has no source query yet`)
};

const nl_ledger_error_no_query = /** @type {(inputs: Ledger_Error_No_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het sjabloon heeft nog geen bronquery`)
};

/**
* | output |
* | --- |
* | "The template has no source query yet" |
*
* @param {Ledger_Error_No_QueryInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_no_query = /** @type {((inputs?: Ledger_Error_No_QueryInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_No_QueryInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_no_query(inputs)
	return en_ledger_error_no_query(inputs)
});